import { ERROR_MESSAGES } from "../../constant/messages";
import { REGEX_PATTERNS } from "../regexPatterns";

/**
 * Validates the username and password fields for login forms.
 * 
 * @param {Object} credentials - An object containing `username` and `password`.
 * @returns {Object} An object containing `valid` (boolean) and `message` (string).
 */
export const validateLoginFields = (credentials) => {
    const { email, password } = credentials;

    if (!email && !password) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_FIELDS };
    }
    if (!email) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_USERNAME };
    }
    if (!password) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_PASSWORD };
    }
    return { valid: true };
};

/**
 * Validates the fields for user registration.
 * 
 * @param {Object} userData - An object containing user registration data (e.g., email, password, confirmPassword).
 * @returns {Object} An object containing `valid` (boolean) and `message` (string).
 */


export const validateRegistrationFields = (registerData) => {
    const { first_name, last_name, email, contact, password } = registerData;

    // === First Name ===
    if (!first_name) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_FIRST_NAME };
    }
    if (!REGEX_PATTERNS.NAME.test(first_name)) {
        return {
            valid: false,
            message: ERROR_MESSAGES.AUTH.INVALID_FIRST_NAME,
        };
    }

    // === Last Name ===
    if (!last_name) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_LAST_NAME };
    }
    if (!REGEX_PATTERNS.NAME.test(last_name)) {
        return {
            valid: false,
            message: ERROR_MESSAGES.AUTH.INVALID_LAST_NAME,
        };
    }

    // === Email ===
    if (!email) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_EMAIL };
    }
    if (!REGEX_PATTERNS.EMAIL.test(email)) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.INVALID_EMAIL };
    }

    // === Password ===
    if (!password) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_PASSWORD };
    }
    if (!REGEX_PATTERNS.PASSWORD.test(password)) {
        return {
            valid: false,
            message: ERROR_MESSAGES.AUTH.INVALID_PASSWORD,
        };
    }

    // === Contact ===
    if (!contact) {
        return { valid: false, message: ERROR_MESSAGES.AUTH.EMPTY_CONTACT };
    }
    if (!REGEX_PATTERNS.CONTACT.test(contact)) {
        return {
            valid: false,
            message: ERROR_MESSAGES.AUTH.INVALID_CONTACT,
        };
    }

    return { valid: true };
};


/**
 * Validates the fields for Building.
 * 
 * @param {Object} saleData - An object containing building adding data (buildingName, buildignAddress).
 * @returns {Object} An object containing `valid` (boolean) and `message` (string).
 */
export const validateBuildingFields = (buildingData) => {

    if (!buildingData.building_name) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_BUILDING_NAME };
    }
    if (!buildingData.building_address) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_BUILDING_ADDRESS };
    }
    return { valid: true };
};

/**
 * Validates the fields for Building.
 * 
 * @param {Object} saleData - An object containing building adding data (buildingName, buildignAddress).
 * @returns {Object} An object containing `valid` (boolean) and `message` (string).
 */
export const validateRentalPropertyFields = (propertyData) => {

    if (!propertyData.property_name) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_RENTAL_PROPERTY_NAME };
    }
    if (!propertyData.property_address) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_RENTAL_PROPERTY_ADDRESS };
    }
    return { valid: true };
};

/**
 * Validates the fields for Building.
 * 
 * @param {Object} saleData - An object containing building adding data (buildingName, buildignAddress).
 * @returns {Object} An object containing `valid` (boolean) and `message` (string).
 */
export const validateTenantFields = (tenantData) => {

    if (!tenantData.tenant_first_name) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_FIRSTNAME };
    }
    if (!tenantData.tenant_contact) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_CONTACT };
    }

    if (!tenantData.uid_number) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_UID };
    }
    if (!tenantData.entry_date) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_ENTRY_DATE };
    }

    if (!tenantData.annual_increment_date) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_ANNUAL_INCREMENT_DATE };
    }
    if (!tenantData.building_id) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_BUILDING_NAME };
    }

    if (!tenantData.property_id) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_RENTAL_PROPERTY_NAME };
    }
    if (!tenantData.rent_amount) {
        return { valid: false, message: ERROR_MESSAGES.VALIDATION.EMPTY_RENT_PRICE };
    }
    return { valid: true };
};